export default {
  loadMaterialIcons: (state: any) => state.browser.config.skipMaterialIcons !== true,
  ready: (state: any) => state.browser.ready as boolean,
  restoringSession: (state: any) => state.browser.restoringSession as boolean,
  visible: (state: any) => state.auth.accessToken || state.browser.config.hideWhenLoggedOut !== true,
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/selectors.tsx